import { DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS, SelectionGroupOption } from 'common/components';
import i18n from '../../../../../i18n.config';
import { CEILINGS_CDN_PATH, CEILINGS_LANDING_NAME } from '../../ceilings-constants';
import {
  CeilingsTypeTabName,
  MOUNTING_TYPE_GALLERY_NAME_LIST,
  LIGHTING_TYPE_GALLERY_NAME_LIST,
} from './ceilings-gallery-section-constants'
import { CeilingsGalleryStructure } from './ceilings-gallery-section-types';

const createGalleryImage = (typeName: 'lighting' | 'mounting', index: number, alt: string) => {
  const imageName = `${index + 1}.jpg`;

  return {
    src: `${CEILINGS_LANDING_NAME}/gallery-popup/${typeName}-type/${imageName}/${imageName}`,
    srcThumb: `${CEILINGS_CDN_PATH}/gallery-popup-thumb/${typeName}-type/${imageName}/${imageName}`,
    srcSmall: `${CEILINGS_LANDING_NAME}/gallery/${typeName}-type/${imageName}/${imageName}`,
    alt: i18n.t(alt),
    name: `${imageName}`,
  };
};

export const createMountingTypeGalleryList = (nameList: string[]) =>
  nameList.map((name, index) => {
    const baseInfo = createGalleryImage('mounting', index, name);

    if ((index % 10 === 4 || index % 10 === 7 || index === 39 || index === 42) && index !== 44) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  });

export const createLightingTypeGalleryList = (nameList: string[]) =>
  nameList.map((name, index) => {
    const baseInfo = createGalleryImage('lighting', index, name);

    if (index % 10 === 4 || index % 10 === 7) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  });


export const getCeilingsTypeList = (): SelectionGroupOption[] => [
  {
    text: i18n.t('gallery-section.tabs.first'),
    value: CeilingsTypeTabName.MountingType,
  },
  {
    text: i18n.t('gallery-section.tabs.second'),
    value: CeilingsTypeTabName.LightingType,
  },
];

export const getCeilingsGallery = (tabName: CeilingsTypeTabName): CeilingsGalleryStructure[] => {
  if (tabName === CeilingsTypeTabName.MountingType) {
    return createMountingTypeGalleryList(MOUNTING_TYPE_GALLERY_NAME_LIST);
  }
  
  return  createLightingTypeGalleryList(LIGHTING_TYPE_GALLERY_NAME_LIST);
};
